import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '@/context'
// import { importLocaleData, enLocale } from '@/locale/locale'
import locale from '@/locale/locale'

function useLocale() {
  const { lang } = useContext(GlobalContext)
  return locale[lang]

  // const [langData, setLangData] = useState<Record<string, string>>(enLocale)

  // useEffect(() => {
  //   const asyncImportLocaleData = async () => {
  //     if (!lang) {
  //       return
  //     }

  //     importLocaleData(lang).then((data) => {
  //       setLangData(data)
  //     })
  //   }

  //   asyncImportLocaleData()
  // }, [lang])

  // return langData
}

export default useLocale
